module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 014.61975754.jpg";